import {apiConstants} from "../../constants/ApiConstants";

import {newItemsList} from "./NewItemList";
import {ParseResultList} from "../views/ParseResultList";

export let ParseResultListContainer = newItemsList(ParseResultList, apiConstants.API_URL + '/auction');
